import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/privateClients/massEdit', request)
}

export {post}
